import axios from 'axios';
import { API_CONFIG } from '../config/env';
import { unwrapApiString } from '../utils/apiResponse';

class WebhooksService {
  private getAuthHeaders() {
    const token = localStorage.getItem('accessToken');
    return {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    };
  }

  async getWebhook(): Promise<string | null> {
    try {
      const response = await axios.get(`${API_CONFIG.BASE_URL}/webhooks`, {
        headers: this.getAuthHeaders(),
      });
      return unwrapApiString(response.data);
    } catch (error) {
      if (axios.isAxiosError(error) && error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  }

  async setWebhook(url: string): Promise<void> {
    await axios.post(`${API_CONFIG.BASE_URL}/webhooks`, url, {
      headers: this.getAuthHeaders(),
    });
  }

  async deleteWebhook(): Promise<void> {
    await axios.delete(`${API_CONFIG.BASE_URL}/webhooks`, {
      headers: this.getAuthHeaders(),
    });
  }

  async generateWebhookToken(): Promise<string> {
    const response = await axios.post(`${API_CONFIG.BASE_URL}/webhooks/generate-token`, {}, {
      headers: this.getAuthHeaders(),
    });
    const token = unwrapApiString(response.data);
    if (!token) {
      throw new Error('Webhook token was not returned by the server');
    }
    return token;
  }
}

export const webhooksService = new WebhooksService();
